export const mockWorkshops = [
  {
    id: 'w1',
    title: "Obituary Writing Workshop",
    date: "2024-04-20",
    time: "14:00 EST",
    facilitator: "Dr. Sarah Jenkins",
    category: "Tribute",
    description: "Learn how to capture the true essence of a life through words in this guided session.",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?q=80&w=1973&auto=format&fit=crop",
    attendees: 12,
    duration: "90 min"
  },
  {
    id: 'w2',
    title: "Navigating Digital Legacies",
    date: "2024-04-22",
    time: "11:00 EST",
    facilitator: "Marcus Vane",
    category: "Legal",
    description: "A technical guide to managing social media and digital assets after a passing.",
    image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?q=80&w=2074&auto=format&fit=crop",
    attendees: 45,
    duration: "60 min"
  },
  {
    id: 'w3',
    title: "Healing Through Heritage",
    date: "2024-04-25",
    time: "18:30 EST",
    facilitator: "Elena Rodriguez",
    category: "Support",
    description: "Exploring cultural traditions and communal mourning practices from around the world.",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=2070&auto=format&fit=crop",
    attendees: 28,
    duration: "120 min"
  },
  {
    id: 'w4',
    title: "Estate Planning 101",
    date: "2024-05-02",
    time: "10:00 EST",
    facilitator: "Atty. Robert Chen",
    category: "Legal",
    description: "Simplifying the complexities of wills, trusts, and final arrangements.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=2070&auto=format&fit=crop",
    attendees: 64,
    duration: "75 min"
  }
];